import { IFirestoreTopicRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreTopicRepository";
import { FirestoreDataRepositoryFactory } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreDataRepositoryFactory";
import { enumFirestoreDataRepositoryDataType } from "../../../cloudServices/googleFirebaseServices/database/firestore/enums";
import { IFirestoreBaseRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreBaseRepository";
import { ITopic, ITopicAsJson } from "../../../../dataObjects/models/topics/Topic";


export function deleteTopic(topic: ITopic): Promise<void> {
  return new Promise<void>(async (resolve, reject) => {
    try {
      // get a Topic repository from the repository factory
      const firestoreTopicRepository: IFirestoreTopicRepository =
        FirestoreDataRepositoryFactory.CreateDataRepository(enumFirestoreDataRepositoryDataType.Topic) as
        IFirestoreBaseRepository<ITopic, ITopicAsJson>;

      // call the repository delete() method to delete the object
      await firestoreTopicRepository.delete(topic.id);

      resolve();
    } catch (error: any) {
      reject(error);
    }
  });
}